import { Injectable, ErrorHandler } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from '../local.storage.service/local.storage.service';
import { AuthService } from '../../services/auth.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private localStorage: LocalStorageService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).do(() => { }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          const prevUrl = this.localStorage.get(AuthService.unauthorizedReturnUrl);
          if (!prevUrl) { 
            this.localStorage.set(AuthService.unauthorizedReturnUrl, this.router.routerState.snapshot.url); 
          }

          this.router.navigate(['/unauthorized']);
        }
      }
    });
  }
}

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor() {
    super();
  }

  handleError(error) {
    if (error.rejection && (!error.rejection.status || error.rejection.status !== 401)) {
      console.error(error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/global.http.error.handler/error.handler.ts